import { Product } from "@/types";
import { router } from "@inertiajs/react";
import { Button } from "../ui/button";

interface ListSummaryProps {
  listProducts: Product[];
  listPrice: number;
}

export const ListSummary = ({ listProducts, listPrice }: ListSummaryProps) => {
  const handleRequestForOffert = () => {
    router.visit("/forms");
  };

  return (
    <section className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
      
      { listProducts?.length > 0 && (
        <div className="flex items-center gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:shadow-md justify-between font-semibold text-gray-900">
          <div>
            <p>Suma: {listPrice.toFixed(2)} zł</p>
            <p>Liczba produktów: {listProducts.length}</p>
          </div>

          <Button
            onClick={handleRequestForOffert}
            className="h-12 px-4 py-2 bg-green-600 text-white font-semibold cursor-pointer rounded-md hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
          >
            Wyślij zapytanie o ofertę
          </Button>
        </div>
      )}

    </section>
  );
}